import type { FC } from "react";

import { cn } from "@/lib/utils";

import { segmentMentions } from "./mentions";

type Props = {
  text: string;
  className?: string;
};

/** Stored text with `@Name <user:uid>` tokens shown as `@Name` chips. */
export const MentionedText: FC<Props> = ({ text, className }) => (
  <span className={cn("whitespace-pre-wrap break-words", className)}>
    {segmentMentions(text).map((seg, i) =>
      seg.type === "text" ? (
        <span key={i}>{seg.text}</span>
      ) : (
        <span
          key={i}
          data-testid={`mention-${seg.kind}`}
          className={cn(
            "rounded-xs px-0.5 font-medium",
            seg.kind === "artifact"
              ? "text-fg-2"
              : "bg-accent-soft text-accent-seed"
          )}
        >
          @{seg.label}
        </span>
      )
    )}
  </span>
);
